import {Component, ElementRef, Injectable, OnInit, Renderer2} from '@angular/core';
import moment from 'moment-mini';
import {RewardService} from '../../../shared/services/reward.service';
import {RewardModel} from '../../../shared/services/data.model';
import {RewardsSummaryService} from '../../../shared/services/rewards-summary.service';
import {ClipService} from '../../../shared/services/clip.service';
import {RewardsToasterService} from '../../../shared/services/rewards-toaster.service';
import {RewardsToasterArgs, RewardsToasterType} from '../../../shared/services/rewards-toaster.interface';
import {ActivatedRoute} from '@angular/router';
import {properties} from '../../../../environments/properties';
import {AuthService} from '../../../shared/services/auth.service';
import {ParamService} from '../../../shared/services/param.service';
import {
    UserInfoService,
    IConfigObj, CartService, CommonService
} from 'abs-ngx-library/src/lib/core';
import {environment} from "../../../../environments/environment";
import {take} from "rxjs/operators";

declare var $: any;

// Window global declaration
function _window(): any {
    return window;
}

@Component({
    selector: 'point-reward-detail',
    templateUrl: './point-reward-detail.component.html',
    styleUrls: ['./point-reward-detail.component.scss']
})

@Injectable()
export class PointRewardDetailComponent implements OnInit {
    public reward: RewardModel = new RewardModel;
    public error: boolean = false;
    public errorMessage: string = '';
    public showLoading: boolean = true;
    public isAuthenticated: boolean = false;
    public rewardsAvailable: number;
    public rewardPoints: number;
    public rewardsExpire: number;
    public rewardsNeededFlag: boolean = false;
    public rewardNewRefreshDisabled: boolean = false;
    public sm = '575px';
    public md = '768px';
    private imagePath: string = window['AB']['dMTProductCard'];
    public disableMulticlipRewardGallery: boolean;
    public disableToastmessageRewardPage: boolean;
    private component: any;
    public returnTotalPoint: number = 0;
    public isPointsHistoryEnabled: boolean = false;
    public pointsAvailable: number;
    public currentCartObjectCounter: number = -1; 
    public firstChangeCartCounter: boolean = true;
    public rewardClipCount: number  = 0; 
    public UPCSetList: any = {};
    public eligibleItemsTrueCounter: number = 0;
    cartCurrentItemCount: number = 0;
    warningTrigger: boolean = false;
    userInfo: any;
    banner: any;
    currentEnvironment: any;
    showPointsScoreCard: boolean;
    enableCashRewards: boolean;
    rewardId: any;
    rewardOfferType: any;
    public appHostURL: any;
    myList = false;
    disabledButton = false;
    rewardsResponseObject: any;
    dataValue : any;
    isBoostYourPointsCardFlow = true;
    public isEligibleProductActive: boolean = false;
    public showEligibleProducts: boolean = false;
    configObj: any;
    pageName = 'reward-detail';
    clipInProgress = false;
    showGrid: boolean = false;
    upcDataAPI: any;
    componentloadingDone = false;
    tokenCaller = 'rewards-detail';


    public constructor(private elementRef: ElementRef,
                       private _rewardSummaryService: RewardsSummaryService,
                       private _rewardService: RewardService,
                       private _couponService: ClipService,
                       private _rewardsToasterService: RewardsToasterService,
                       private _renderer: Renderer2,
                       private router: ActivatedRoute,
                       private clipService: ClipService,
                       private authService: AuthService,
                       private paramService: ParamService,
                       private _userInfoService: UserInfoService,
                       private cartService: CartService,
                       private _commonService: CommonService) {
    }

    /**
     * Subscribe and receive reward details from service.
     */
    public ngOnInit(): void {
        this.banner = this.paramService.banner;
        this.isEligibleProductActive = properties.rewardsConfig.eligibleProductFlow[this.banner];
        this.showPointsScoreCard = properties.rewardsConfig.rewardsSimplifiedBanner[this.banner];
        this.enableCashRewards = properties.rewardsConfig.cashRewardsBanner[this.banner];
        this.currentEnvironment = this._rewardSummaryService.getEnvironment();
        this.appHostURL = this.authService.getApplicationDomainURL();
        this.rewardId = this.router.snapshot.queryParamMap.get('rewardId') ? this.router.snapshot.queryParamMap.get('rewardId') : null;
        this.rewardOfferType = this.router.snapshot.queryParamMap.get('rewardOfferType') ? this.router.snapshot.queryParamMap.get('rewardOfferType') : null;
        this.myList = this.router.snapshot.queryParamMap.get('myList') ? true : false;
        this.disableMulticlipRewardGallery = properties.rewardsConfig.disableMulticlipRewardGallery;
        this.disableToastmessageRewardPage = properties.rewardsConfig.disableToastmessageRewardPage;
        $('.prompt-message__close-button').click(function () {
            $('#promptMessageModal').toast('hide');
        });
        $('#promptMessageModal a').attr('href', 'javascript:$(\'#rewards-selected-modal\').modal({show:true})');
        const abCart = localStorage.getItem('abCart');
        if(abCart) {    
            const cartObj = JSON.parse(abCart);
            if(cartObj.cart && cartObj.cart.cartQty)
            this.cartCurrentItemCount = JSON.parse(abCart)
        }
        this.initSubscription();
        this.getUserInfo();
        if (window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].initAngularSPA) {
            window['AB']['DATALAYER'].initAngularSPA('rewards', 'point-reward-details');
        }
    }

    getUserInfo() {
        this.authService.rewardsDetailSessionData$.subscribe((userInfo) => {
            if (userInfo) {
                this.userInfo = userInfo;
                if (userInfo.isTokenValid) {
                    this._init();
                } else {
                    this.authService.redirectToSSO(userInfo.tokenObject);
                }
            } else {
                this.authService.getUserLogedInToken(this.tokenCaller);
            }
        });
    }

    initSubscription() {
        this.clipService.rewardsRefresh.subscribe(data => {
            if (data) {
                //_window()['location']['href'] = '/rewards/dashboard';
                if (this.authService.isTokenValidForSession(this.userInfo)) {
                    this._init();
                } else {
                    this.authService.redirectToSSO(this.userInfo);
                }
            }
        });
        this._commonService.currentCartObj.subscribe(cartObj => {
            if (cartObj && cartObj.cart && cartObj.cart.abs && cartObj.cart.abs.cartQty > this.cartCurrentItemCount) {
                this.cartCurrentItemCount = cartObj.cart.abs.cartQty;
                // if (cartObj.cartItems.length >= 0 && this.currentCartObjectCounter == -1 && this.firstChangeCartCounter){
                //     // first time setting up  current cart object counter and set first changer indicator to false
                //     this.currentCartObjectCounter = cartObj.cartItems.length;
                //     this.firstChangeCartCounter = false;
                // }
                // if (cartObj.cartItems.length <= this.currentCartObjectCounter && !this.firstChangeCartCounter){
                //     // when there is a decrease in cart object just update current cart object counter
                //     this.currentCartObjectCounter = cartObj.cartItems.length;
                // }
                // if (cartObj.cartItems.length > this.currentCartObjectCounter && !this.firstChangeCartCounter){
                    // when there is a increase in cart object , first update current cart object counter
                    // this.currentCartObjectCounter = cartObj.cartItems.length;

                    // set rewardClipCount
                   if (this.reward.usageType == 'M') {
                        this.rewardClipCount = this.reward.clipDetails.clippedCount;
                    }else{
                        this.rewardClipCount = this.reward.status=='C'? 1 : 0;
                    }
                    // check if UPC setList is not empty (there are eligible items for the reward)
                    if (this.UPCSetList && this.UPCSetList.size >0 && this.warningTrigger){
                        cartObj['cartItems'].forEach(cartItem =>{
                            if(this.UPCSetList.has(cartItem.upc)){
                                //set eligibleItemsTrueCounter
                                this.eligibleItemsTrueCounter += cartItem.quantityValue;
                            }
                        })
                        const eligibleItemNotifiactionNoShowIndicatorString = 'EligibleItemNotifiactionNoShowIndicator-' + this.rewardId
                        const eligibleItemNotifiactionNoShowIndicator = JSON.parse(window.localStorage.getItem(eligibleItemNotifiactionNoShowIndicatorString));
                        // check if eligibleItemsTrueCounter > rewardClipCount && NOT eligibleItemNotifiactionIndicator
                        if(this.eligibleItemsTrueCounter > this.rewardClipCount && this.rewardClipCount > 0 && !eligibleItemNotifiactionNoShowIndicator){
                            // set eligibleItemNotifiactionNoShowIndicator to true
                            window.localStorage.setItem(eligibleItemNotifiactionNoShowIndicatorString, JSON.stringify(true));
                            // display Toast 
                            let message = "";
                            let type = RewardsToasterType.CompletelyExpired;
                            type = RewardsToasterType.CompletelyExpired;
                            message = 'You’ve added more than the max number of eligible items. Additional items will be charged at checkout.';
                            let toastArgs = {
                                message: message,
                                type: type
                            }
                            this.createToast(toastArgs);
                        }
                    }
                    this.warningTrigger = true;
                //}
            }else if(cartObj && cartObj.cart && cartObj.cart.abs && cartObj.cart.abs.cartQty <= this.cartCurrentItemCount){
                this.cartCurrentItemCount = cartObj.cart.abs.cartQty;
            }
        });
    }

    private _init() {
        // window.scrollTo(0,window.outerHeight/2) // scroll to middle of the page so eligble items is visble to the user
        const _this = this;
        // Get updated rewards summary
        if (!this.disableToastmessageRewardPage) {
            if (localStorage.getItem('isRewardDetail')) {
                localStorage.removeItem('isRewardDetail');
            }
            //localStorage.setItem('isRewardDetail', 'reward-detail');
        }
        // Get Reward Details

        this._rewardService.getOneRewardMulticlip(this.rewardId, this.rewardOfferType, this.currentEnvironment, this.userInfo)
            .subscribe(data => {
                if (data) {
                    //this.rewardNewRefreshDisabled = true;
                    if(this.isEligibleProductActive) {
                        const scrollIndicator = JSON.parse(window.localStorage.getItem('scrollIndicator'));
                        this.showGrid = true;
                        const userInfo = this.updateUserInfo(this.userInfo);
                        this._userInfoService.setUserSession(userInfo);
                        this._commonService.postUserInfoSource.next('initFunc');
                        this._commonService._postUserInfoSource.next('initFunc');
                        this._commonService.upcs.next(data['upcList']);

                        if(data['upcList'] && data['upcList'].length > 0 && scrollIndicator){
                            setTimeout(function(){
                                document.getElementById('offer-details').scrollIntoView();
                            },1000)
                        }
                        if(scrollIndicator){
                            window.localStorage.removeItem('scrollIndicator');
                        }
                    }
                    this.reward = data;
                    this.UPCSetList = new Set(this.reward.upcList);
                    this.getPointSummaryData();
                    this.componentloadingDone = true;
                } else {
                    this._showError('No points available.');
                }
                this.showLoading = false;
            }, err => this._showError('No points available for you at this moment.'));
    }


    public checkForExpirePoint() {
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            let message = "";
            let type = RewardsToasterType.Error;
            this._couponService.checkUnclipDetail(this.reward, this.userInfo, this.currentEnvironment)
                .subscribe(data => {
                    if (data) {
                        const totalPoints = data.totalClippedPoints; //TODO: Use actual points instead of rewards;
                        const expiredPoints = data.expiredPoints; //TODO: Use actual points instead of rewards;
                        const nonexpiredPoints = totalPoints - expiredPoints;
                        this.returnTotalPoint = nonexpiredPoints;
                        if (data.isValidForUnClip) {
                            if (data.isPartiallyExpired) {
                                if (nonexpiredPoints != 0) {
                                    type = RewardsToasterType.PartiallyExpired;
                                    message = expiredPoints + " of " + totalPoints + ' Points have expired and cannot be reclaimed.';
                                    let toastArgs = {
                                        message: message,
                                        type: type,
                                        continueCb: () => this.reward.usageType == "M" ? this.unclipRewardMultiClip() : this.unclipReward()
                                    }
                                    this.createToast(toastArgs);
                                }
                            } else {
                                this.clipInProgress = true;
                                this.reward.usageType == "M" ? this.unclipRewardMultiClip() : this.unclipReward();
                            }
                        } else {
                            type = RewardsToasterType.CompletelyExpired;
                            message = 'The Points used for this offer have expired and cannot be reclaimed.';
                            let toastArgs = {
                                message: message,
                                type: type
                            }
                            this.createToast(toastArgs);
                        }
                    }
                })
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }
    }

    private createToast(args: RewardsToasterArgs): void {
        let autoCloseTime = RewardsToasterService.autoCloseTime;
        if (args.type == RewardsToasterType.PartiallyExpired) {
            autoCloseTime = 0;
        }
        let toastElement: HTMLElement = this._rewardsToasterService.createToast(
            {message: args.message, type: args.type, autoCloseTime},
            args.continueCb ? args.continueCb : () => {
            },
            args.closeCb ? args.closeCb : () => {
            },
            true
        );
        let contentElement = document.querySelector('.reward-details-container');
        if (toastElement && contentElement) {
            this._renderer.appendChild(contentElement, toastElement);
        } else {
            contentElement = document.querySelector('.reward-grid-container');
            if (toastElement && contentElement) {
                this._renderer.appendChild(contentElement, toastElement);
            }
        }
    }

    private getAllRewards() {
        this._rewardService.getDataMulticlip(this.userInfo, this.currentEnvironment, true).subscribe(data => {
            if (data) {
                let rewardsOffers = data.offers;
                let moreWaysToUseOffers = data.moreWaysToUseOffers;
                if (rewardsOffers && rewardsOffers.length > 0) {
                    rewardsOffers.forEach(dataChild => {
                        if (dataChild.groceryRewardId === this.rewardId) {
                            this.reward['rewardsRequired'] = dataChild.rewardsRequired;
                            this.reward['groceryRewardId'] = dataChild.groceryRewardId;
                            this.reward['pointsRequired'] = dataChild.pointsRequired;
                        }
                    });
                }
                if(moreWaysToUseOffers && moreWaysToUseOffers.length > 0){
                    moreWaysToUseOffers.forEach(dataChild => {
                        if (dataChild.groceryRewardId === this.rewardId) {
                            this.reward['rewardsRequired'] = dataChild.rewardsRequired;
                            this.reward['groceryRewardId'] = dataChild.groceryRewardId;
                            this.reward['pointsRequired'] = dataChild.pointsRequired;
                        }
                    })
                }

                this.showLoading = false;
                this.rewardsNeededFlag = true;
                this.clipInProgress = false;
            }
        }, error => {
            const errorTitle = 'Service Problem';
            const errorMessage = 'System is currently unavailable, please try again later.';
            window['AB']['COMMON'].popupUserErrorMessage(errorTitle, errorMessage, function () {
                // Refresh the page after user clicks the button.
                window.location.href = '/rewards/dashboard';
            });
        });
    }

    private getPointSummaryData() {
        let rwdObj = {
            rewards: {
                balance: 0,
                dollarDiscount: 0,
                points: null,
                autoRewardsPoints: 0,
                willExpire: 0,
                isUserHasRewards: false
            }
        };
        const programType = 'BASEPOINTS';
        this._rewardSummaryService.getRewardsScoreCardV3(this.currentEnvironment, programType, this.userInfo).subscribe((data: any) => {
            if (data && data.scorecards && data.scorecards.length > 0) {
                let scoreCard = data.scorecards.find(scorecard => {
                    return scorecard.programType === 'BASEPOINTS';
                });
                if (scoreCard) {
                    this.pointsAvailable = ((scoreCard.balance < 0) ? 0 : scoreCard.balance);
                    if (scoreCard) {
                        rwdObj.rewards.balance = ((scoreCard.balance < 0) ? 0 : scoreCard.balance);
                        rwdObj.rewards.points = scoreCard.points;
                        rwdObj.rewards.dollarDiscount = ((scoreCard.dollarDiscount < 0) ? 0 : scoreCard.dollarDiscount);
                        rwdObj.rewards.autoRewardsPoints = ((scoreCard.autoRewardsPoints < 0) ? 0 : scoreCard.autoRewardsPoints);
                        rwdObj.rewards.willExpire = ((scoreCard.willExpire < 0) ? 0 : scoreCard.willExpire);
                        rwdObj.rewards.isUserHasRewards = true;
                    }
                } else {
                    this.pointsAvailable = 0;
                }
                this.reward['pointsAvailable'] = this.pointsAvailable;
            } else {
                this.pointsAvailable = 0;
                this.reward['pointsAvailable'] = this.pointsAvailable;
            }
            this.rewardsResponseObject = rwdObj;
            this.getAllRewards();
        }, error => {
            this.pointsAvailable = 0;
            this.reward['pointsAvailable'] = this.pointsAvailable;
            this.rewardsResponseObject = rwdObj;
            this.getAllRewards();
        });
    }

    private dateConversion(dateServer: string): string {
        let dateStr = dateServer;
        let regex = /\d+/;
        let mills = regex.exec(dateStr);
        let d = new Date(parseInt(mills[0]));
        d.setUTCMilliseconds(mills.index);
        let dateOutput = d.toLocaleDateString("en-US");
        return dateOutput
    }

    /**
     * Replace reward's content with error message.
     *
     * @param {string} errorMessage Error to be shown.
     */
    private _showError(errorMessage) {
        this.showLoading = false;
        this.error = true;
        this.errorMessage = errorMessage;
    }

    public clipReward() {
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            this.clipToastMessage();
            this.clipInProgress = true;
            this._couponService.clipReward(this.reward, this.updateStatistics.bind(this), this.rewardNewRefreshDisabled, this.userInfo, this.currentEnvironment, false, this.showPointsScoreCard, false);
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }

    }

    public unclipReward() {
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            this.unclipToastMessage();
            this.clipInProgress = true;
            this._couponService.unclipReward(this.reward, this.unclipMulticlipUpdateStatistics.bind(this), this.rewardNewRefreshDisabled, this.userInfo, this.currentEnvironment, false, this.showPointsScoreCard);
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }
    }

    public openRewardsModal() {
        this._couponService.openRewardsModalSource.next(true);
    }

    public clipToastMessage() {

        const rewardString = this.reward.pointsRequired > 1 ? ' Points.' : ' Point.';
        const toasterArgs = {
            message: 'Used ' + this.reward.pointsRequired + rewardString,
            type: RewardsToasterType.SuccessGoToRewards,
            continueCb: () => this.openRewardsModal()
        };
        this.setLocalStorageForToaster(toasterArgs);

    }

    public unclipToastMessage() {
        const rewardString = this.returnTotalPoint > 1 ? ' Points. ' : ' Point. ';
        const toasterArgs = {
            message: 'Reclaimed ' + this.returnTotalPoint + rewardString + 'It may take a few minutes to update your account.',
            type: RewardsToasterType.Success,
        };
        this.setLocalStorageForToaster(toasterArgs);

    }

    public unclipRewardMultiClip() {
        if (this.authService.isTokenValidForSession(this.userInfo)) {
            this.unclipToastMessage();
            this.clipInProgress = true;
            this._couponService.unclipRewardMulticlip(this.reward, this.unclipMulticlipUpdateStatistics.bind(this), this.rewardNewRefreshDisabled, this.userInfo, this.currentEnvironment, false, this.showPointsScoreCard);
        } else {
            this.authService.redirectToSSO(this.userInfo);
        }
    }

    private updateStatistics() {
        // $('#promptMessageModal').toast('show');
        let rewardString;
        let toasterArgs;
        rewardString = this.reward.pointsRequired > 1 ? " Points." : " Point."
        toasterArgs = {
            message: "Used " + this.reward.pointsRequired + rewardString,
            type: RewardsToasterType.Success,
        }
        this.clipInProgress = false;
        this.createToast(toasterArgs);
        this._init();

    }

    public clipByDateCheck(): boolean {
        let today = moment();
        let endDateString = this.reward.displayEndDate;
        let newdate = new Date(endDateString + 'T00:00');
        let rewardEndDate = moment(newdate).format('MM/DD/YYYY');
        return today.diff(rewardEndDate, 'days') <= 0;
    }

    public setLocalStorageForToaster(toasterArgs: any) {
        if (localStorage.getItem('rewardClipAndUnclipToastData')) {
            localStorage.removeItem('rewardClipAndUnclipToastData');
        }
        localStorage.setItem('rewardClipAndUnclipToastData', JSON.stringify(toasterArgs));
    }

    private unclipMulticlipUpdateStatistics() {
        let rewardString;
        let toasterArgs;
        rewardString = this.returnTotalPoint > 1 ? " Points. " : " Point. "
        toasterArgs = {
            message: "Reclaimed " + this.returnTotalPoint + rewardString + "It may take a few minutes to update your account.",
            type: RewardsToasterType.Success,
        }
        this.clipInProgress = false;
        this._init();
        this.createToast(toasterArgs);
    }

    public getImageUrl(id: string, viewport: string): String {
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
    }
    public updateUserInfo(userInfo) {
        window["AB"].userInfo.SWY_SHOP_TOKEN = userInfo.SWY_SHOP_TOKEN;
        window["AB"].userInfo.email = userInfo.email;
        window["AB"].userInfo.banner = userInfo.banner || this.banner;
        window["AB"].userInfo.j4u.zipcode = userInfo.j4uZipcode;
        window["AB"].userInfo.clubCard = userInfo.clubCardNumber;
        window["AB"].userInfo.j4u.storeId = userInfo.j4uStoreId ? userInfo.j4uStoreId : userInfo.storeId;
        window["AB"].userInfo.firstName = userInfo.firstName;
        window["AB"].userInfo.displayableBanner = userInfo.displayableBanner;
        window["AB"].userInfo.pickupAddress = userInfo.pickupAddress;
        window["AB"].userInfo.customerId = userInfo.customerId;
        window["AB"].userInfo.userType = userInfo.userType;
        window["AB"].userInfo.UUID = userInfo.UUID;
        window["AB"].userInfo.branchId = userInfo.j4uStoreId;
        window["AB"].userInfo.expireTime = userInfo.expireTime;

        const userInfoOnject = {...window['AB']['userInfo'], shopStoreId:window["AB"].userInfo.j4u.storeId,shopZipcode:window["AB"].userInfo.j4u.zipcode, j4uStoreId:window["AB"].userInfo.j4u.storeId, j4uZipcode:window["AB"].userInfo.j4u.zipcode, preference: userInfo.preference}
        return userInfoOnject;
    }

    clipNonRefundOffers(event) {
        if(event) {
            this.reward = event;
            this.clipReward();
        }

    }

    cartNotification(cartitems) {
        if(cartitems && cartitems.length > 0) {
            console.error(cartitems);

        }
    }
}
